<div class="popup-backdrop" (click)="PopupEvent('close')" *ngIf="popup?.Display">
</div>
<div class="popup-component appointment-setup-popup" *ngIf="popup?.Display">
  <div class="popup-container">
    <div class="popup-content">
      <!-- popup header -->
      <div class="popup-header">
        <h2>{{ popup?.Title }}</h2>
      </div>

      <!--Appointment Setup: Patient Search Section-->
      <div class="popup-body" *ngIf="PopupAction == 'Setup'">
        <div class="search-fields-popup">
          <div class="row justify-space-between">
            <div class="title">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
                <path d="M0.848877 5.01198C1.34194 3.60323 3.28201 0.785721 7.09771 0.785721C11.8674 0.785721 14.6048 4.83952 13.7692 8.6345C13.0447 11.9249 10.9919 13.0721 10.0863 13.857C8.76333 15.0035 8.7637 15.939 8.28385 17.4523C8.00632 18.3277 7.04192 19.5759 5.69854 19.7298C4.72496 19.8412 3.55234 19.3779 2.29787 17.7813" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M21.2142 15.3774C21.2142 18.601 18.6009 21.2141 15.3774 21.2141" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M18.5164 15.2673C18.5164 17.0008 17.111 18.4062 15.3774 18.4062" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M15.9063 14.3941C15.9063 15.2 15.253 15.8534 14.4471 15.8534" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M3.68678 7.0646C3.97245 6.35917 4.99146 4.98189 6.78222 5.11631C8.57298 5.25073 10.1106 7.0646 9.47663 8.74762C8.8427 10.4306 8.00486 9.90961 7.24275 11.0419C6.48064 12.1741 6.76531 14.4459 5.06923 14.7851C4.01267 14.9965 3.45776 14.3901 3.45776 14.3901" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <h3>Audiologist:</h3>
            </div>
            <div class="form-group">
              <app-custom-dropdown [options]="doctors"
                                   [placeholder]="'Select an option'"
                                   [(ngModel)]="appointment.AudiologistID"
                                   [optionsText]="'FullName'"
                                   [optionsValue]="'ID'"
                                   (ngModelChange)="AudiologistUpdate()"
                                   tabindex="1">
              </app-custom-dropdown>
            </div>
          </div>
          <div class="row justify-space-between">
            <div class="title">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
                <path d="M20.7116 21.2143C20.0518 19.157 18.7558 17.3624 17.0106 16.0892C15.2651 14.8161 13.1605 14.13 11.0001 14.13C8.83971 14.13 6.73511 14.8161 4.98974 16.0892C3.24439 17.3624 1.94842 19.157 1.2887 21.2143H20.7116Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11 14.1428C14.6729 14.1428 17.6504 11.1654 17.6504 7.49247C17.6504 3.81957 14.6729 0.842102 11 0.842102C7.32709 0.842102 4.34961 3.81957 4.34961 7.49247C4.34961 11.1654 7.32709 14.1428 11 14.1428Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.1717 10.0656C13.1717 10.0656 12.6199 11.1514 11.0002 11.1514C9.38042 11.1514 8.82861 10.0656 8.82861 10.0656" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M17.5299 6.22629C17.515 6.22638 17.5002 6.22643 17.4855 6.22643C15.5523 6.22643 13.8168 5.3807 12.6286 4.03908C11.4404 5.38073 9.70486 6.22648 7.77177 6.22648C6.64923 6.22648 5.5933 5.94128 4.67249 5.4394C5.53762 2.77125 8.04347 0.842102 10.9999 0.842102C14.2398 0.842102 16.9386 3.15897 17.5299 6.22629Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <h3>Staff Member:</h3>
            </div>
            <div class="form-group">
              <app-custom-dropdown [options]="staffList"
                                   [placeholder]="'Select an option'"
                                   [(ngModel)]="appointment.StaffMemberID"
                                   [optionsText]="'FullName'"
                                   [optionsValue]="'ID'"
                                   (ngModelChange)="StaffUpdate()"
                                   tabindex="2">
              </app-custom-dropdown>
            </div>
          </div>

          <div class="row justify-space-between">
            <div class="title">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
                <path d="M3.20508 21.1332V17.2359H7.10246" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M20.9612 9.13794C21.9309 14.2949 18.7752 19.4074 13.6228 20.7879C9.6793 21.8446 5.65566 20.4232 3.20508 17.4784" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M1.03896 12.8622C0.0692254 7.70524 3.22504 2.59272 8.37743 1.21214C12.3206 0.155571 16.344 1.57666 18.7946 4.52111" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M18.7948 0.866852V4.76424H14.8973" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.0001 10.2143C12.0849 10.2143 12.9643 9.33484 12.9643 8.24999C12.9643 7.16515 12.0849 6.28571 11.0001 6.28571C9.91521 6.28571 9.03577 7.16515 9.03577 8.24999C9.03577 9.33484 9.91521 10.2143 11.0001 10.2143Z" stroke="#004D8B" stroke-width="1.5" />
                <path d="M7.39832 14.9286C8.00454 13.5411 9.38903 12.5714 11 12.5714C12.611 12.5714 13.9955 13.5411 14.6017 14.9286" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" />
              </svg>
              <h3>Search by Surname:</h3>
            </div>
            <div class="form-group">
              <div class="search-input">
                <span class="custom-placeholder" *ngIf="!Surname">Enter Surname</span>
                <input type="text" id="surname" [(ngModel)]="Surname" tabindex="3">
                <button (click)="patientsGetBySurname()" type="button">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="search-icon">
                    <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="#EF1010" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M21 21L16.65 16.65" stroke="#EF1010" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="row justify-space-between">
            <div class="title">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
                <path d="M3.20508 21.1332V17.2359H7.10246" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M20.9612 9.13794C21.9309 14.2949 18.7752 19.4074 13.6228 20.7879C9.6793 21.8446 5.65566 20.4232 3.20508 17.4784" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M1.03896 12.8622C0.0692254 7.70524 3.22504 2.59272 8.37743 1.21214C12.3206 0.155571 16.344 1.57666 18.7946 4.52111" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M18.7948 0.866852V4.76424H14.8973" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.0001 10.2143C12.0849 10.2143 12.9643 9.33484 12.9643 8.24999C12.9643 7.16515 12.0849 6.28571 11.0001 6.28571C9.91521 6.28571 9.03577 7.16515 9.03577 8.24999C9.03577 9.33484 9.91521 10.2143 11.0001 10.2143Z" stroke="#004D8B" stroke-width="1.5" />
                <path d="M7.39832 14.9286C8.00454 13.5411 9.38903 12.5714 11 12.5714C12.611 12.5714 13.9955 13.5411 14.6017 14.9286" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" />
              </svg>
              <h3>Search by ID Number:</h3>
            </div>
            <div class="form-group">
              <div class="search-input">
                <span class="custom-placeholder" *ngIf="!IDNumber">Enter ID Number</span>
                <input type="text" id="id-number" [(ngModel)]="IDNumber" tabindex="4">
                <button (click)="patientsGetByIDNumber()" type="button">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="search-icon">
                    <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="#EF1010" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M21 21L16.65 16.65" stroke="#EF1010" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="row justify-space-between">
            <div class="title">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
                <path d="M3.20508 21.1332V17.2359H7.10246" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M20.9612 9.13794C21.9309 14.2949 18.7752 19.4074 13.6228 20.7879C9.6793 21.8446 5.65566 20.4232 3.20508 17.4784" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M1.03896 12.8622C0.0692254 7.70524 3.22504 2.59272 8.37743 1.21214C12.3206 0.155571 16.344 1.57666 18.7946 4.52111" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M18.7948 0.866852V4.76424H14.8973" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.0001 10.2143C12.0849 10.2143 12.9643 9.33484 12.9643 8.24999C12.9643 7.16515 12.0849 6.28571 11.0001 6.28571C9.91521 6.28571 9.03577 7.16515 9.03577 8.24999C9.03577 9.33484 9.91521 10.2143 11.0001 10.2143Z" stroke="#004D8B" stroke-width="1.5" />
                <path d="M7.39832 14.9286C8.00454 13.5411 9.38903 12.5714 11 12.5714C12.611 12.5714 13.9955 13.5411 14.6017 14.9286" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" />
              </svg>
              <h3>Search by Cell Phone:</h3>
            </div>
            <div class="form-group">
              <div class="search-input">
                <span class="custom-placeholder" *ngIf="!Cellphone">Enter Cell Phone</span>
                <input type="text" id="cell-phone" [(ngModel)]="Cellphone" tabindex="5">
                <button (click)="patientsGetByCellphone()" type="button">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="search-icon">
                    <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="#EF1010" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M21 21L16.65 16.65" stroke="#EF1010" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Appointment Setup: Patient Search Cards Section-->
      <div class="popup-body popup-setup-form" *ngIf="PopupAction == 'View'">
        <div *ngIf="patients.length > 0" class="patient-details-card-container">
          <div *ngFor="let patient of patients" class="patient-details-card">
            <div class="title">
              <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
                <g clip-path="url(#clip0_88_5308)">
                  <path d="M7.14286 7.85715C9.1153 7.85715 10.7143 6.25817 10.7143 4.28572C10.7143 2.31328 9.1153 0.714294 7.14286 0.714294C5.17041 0.714294 3.57143 2.31328 3.57143 4.28572C3.57143 6.25817 5.17041 7.85715 7.14286 7.85715Z" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M7.14286 17.8572H0.714287V17.0827C0.72566 15.9939 1.01283 14.9256 1.54896 13.9778C2.0851 13.03 2.85272 12.2336 3.7801 11.6629C4.7075 11.0922 5.76442 10.7658 6.85212 10.7143C6.94909 10.7098 7.04603 10.7074 7.14286 10.7072C7.23969 10.7074 7.33664 10.7098 7.43362 10.7143C8.52132 10.7658 9.57823 11.0922 10.5056 11.6629C11.0389 11.9911 11.5194 12.3939 11.9333 12.8572" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M19.2857 12.1429L13.5714 19.2857L10.7143 17.1429" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_88_5308">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <h3>Patient Details</h3>
            </div>

            <div class="details">
              <div class="content-group">
                <span>Title:</span>
                <div>{{ patient.Title }}</div>
              </div>
              <div class="content-group">
                <span>Patient Name:</span>
                <div>{{ patient.FullName }}</div>
              </div>
              <div class="content-group justify-end">
                <span>Patient Status:</span>
                <span><strong>{{ patient.Status }}</strong></span>
              </div>
              <div class="content-group">
                <span>Gender:</span>
                <div>{{ patient.GenderType }}</div>
              </div>
              <div class="content-group">
                <span>Patient ID:</span>
                <div>{{ patient.IDNumber }}</div>
              </div>
              <div class="content-group justify-end">
                <span>Cellphone:</span>
                <div>{{ patient.Cellphone }}</div>
              </div>

            </div>

            <div class="popup-buttons">
              <button class="popup-btn" type="button" (click)="navigateToEdit(patient)">Edit</button>
              <button class="popup-btn" type="button" (click)="navigateToCapture(patient)">Select</button>
            </div>
          </div>
          <div class="popup-buttons">
            <button class="popup-btn" type="button" (click)="navigateToCaptureNew()">Capture</button>
            <button class="popup-btn" type="button" (click)="navigateToSetup()">Back</button>
          </div>
        </div>
        <div *ngIf="patients.length === 0">
          <div class="container">
            <div class="message-box">
              <p class="error-message">Patient was not found</p>
            </div>
            <div class="popup-buttons justify-center">
              <button class="popup-btn" type="button"  (click)="navigateToSetup()">Back</button>
              <button class="popup-btn" type="button" (click)="navigateToCaptureNew()">Capture</button>
            </div>
          </div>
        </div>
      </div>
      <!--Appointment Setup: Setup Form-->
      <div class="popup-body appointment-setup-form" *ngIf="PopupAction == 'EDIT' || PopupAction == 'SELECT' || PopupAction == 'NEW'">
        <form class="form-container" #f="ngForm" (ngSubmit)="onSubmit(f)">
          <!-- Audiologist and Staff Member Section -->
          <div class="column gap-20">
            <div class="setup-view-title row justify-space-between">
              <div class="title">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
                  <g clip-path="url(#clip0_476_2304)">
                    <path d="M0.848877 5.01203C1.34194 3.60328 3.28201 0.785767 7.09771 0.785767C11.8674 0.785767 14.6048 4.83957 13.7692 8.63455C13.0447 11.925 10.9919 13.0721 10.0863 13.857C8.76333 15.0036 8.7637 15.9391 8.28385 17.4523C8.00632 18.3278 7.04192 19.576 5.69854 19.7298C4.72496 19.8412 3.55234 19.378 2.29787 17.7814" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M21.2142 15.3774C21.2142 18.601 18.6009 21.2141 15.3774 21.2141" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M18.5164 15.2673C18.5164 17.0008 17.111 18.4061 15.3774 18.4061" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M15.9063 14.3942C15.9063 15.2001 15.253 15.8534 14.4471 15.8534" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M3.68678 7.06463C3.97245 6.3592 4.99146 4.98192 6.78222 5.11634C8.57298 5.25076 10.1106 7.06463 9.47663 8.74765C8.8427 10.4306 8.00486 9.90964 7.24275 11.0419C6.48064 12.1742 6.76531 14.4459 5.06923 14.7852C4.01267 14.9965 3.45776 14.3902 3.45776 14.3902" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_476_2304">
                      <rect width="22" height="22" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <h3>Audiologist</h3>
              </div>
              <div class="form-group">
                <app-custom-dropdown [options]="staffList"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="appointment.AudiologistID"
                                     [ngModelOptions]="{standalone: true}"
                                     [optionsText]="'FullName'"
                                     [optionsValue]="'ID'"
                                     tabindex="1">
                </app-custom-dropdown>
              </div>
            </div>
            <div class="setup-view-title row justify-space-between">
              <div class="title">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
                  <g clip-path="url(#clip0_271_4232)">
                    <path d="M20.7116 21.2143C20.0518 19.157 18.7558 17.3624 17.0106 16.0892C15.2651 14.8161 13.1605 14.13 11.0001 14.13C8.83971 14.13 6.73511 14.8161 4.98974 16.0892C3.24439 17.3624 1.94842 19.157 1.2887 21.2143H20.7116Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M11 14.1429C14.6729 14.1429 17.6504 11.1654 17.6504 7.49253C17.6504 3.81963 14.6729 0.842163 11 0.842163C7.32709 0.842163 4.34961 3.81963 4.34961 7.49253C4.34961 11.1654 7.32709 14.1429 11 14.1429Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M13.1717 10.0657C13.1717 10.0657 12.6199 11.1514 11.0002 11.1514C9.38042 11.1514 8.82861 10.0657 8.82861 10.0657" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M17.5299 6.22635C17.515 6.22644 17.5002 6.22649 17.4855 6.22649C15.5523 6.22649 13.8168 5.38076 12.6286 4.03914C11.4404 5.3808 9.70486 6.22654 7.77177 6.22654C6.64923 6.22654 5.5933 5.94134 4.67249 5.43946C5.53762 2.77131 8.04347 0.842163 10.9999 0.842163C14.2398 0.842163 16.9386 3.15903 17.5299 6.22635Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_271_4232">
                      <rect width="22" height="22" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <h3> Staff Member:</h3>
              </div>
              <div class="form-group">
                <span *ngIf="staffMemberError && submitted" class="error-message">*</span>
                <app-custom-dropdown [options]="staffList"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="appointment.StaffMemberID"
                                     [ngModelOptions]="{standalone: true}"
                                     [optionsText]="'FullName'"
                                     [optionsValue]="'ID'"
                                     [ngClass]="{'invalid-border': staffMemberError && submitted}"
                                     tabindex="2">
                </app-custom-dropdown>
              </div>
            </div>
          </div>
          <hr style=" margin: 10px 0;" />
          <!-- Appointment Details Section -->
          <div class="column gap-20">
            <div class="title">
              <h3>Appointment Details</h3>

            </div>
            <div class="row">
              <div class="details-row">
                <div class="form-group form-group-column">
                  <label>Date</label>
                  <app-calendar-dropdown [(selectedDate)]="selectedStartDate" tabindex="3"></app-calendar-dropdown>
                </div>
                <div class="form-group form-group-column">
                  <label>Time</label>
                  <app-custom-dropdown [options]="times"
                                       [placeholder]="'Select an option'"
                                       [(ngModel)]="appointmentTime"
                                       [ngModelOptions]="{standalone: true}"
                                       [optionsText]="'Type'"
                                       [optionsValue]="'Type'"
                                       tabindex="4">
                  </app-custom-dropdown>
                </div>
                <div class="form-group form-group-column">
                  <label>Testing Facility</label>
                  <app-custom-dropdown [options]="serviceAreas"
                                       [placeholder]="'Select an option'"
                                       [(ngModel)]="appointment.LocationID"
                                       [ngModelOptions]="{standalone: true}"
                                       [optionsText]="'ServiceAreaName'"
                                       [optionsValue]="'ID'"
                                       tabindex="5">
                  </app-custom-dropdown>
                </div>
              </div>
            </div>
          </div>
          <hr style=" margin: 10px 0;" />
          <!-- Patient Details Section -->
            <!-- Patient Details: EDIT Section -->
          <div class="details-new column gap-20" *ngIf="PopupAction == 'EDIT'">
            <div class="title">
              <h3>Update Patient Details</h3>
            </div>
            <div class="column gap-20">
              <div class="form-group">
                <span *ngIf="IDNumber.invalid && submitted" class="invalid-text">*</span>
                <label>Patient ID / Passport Number:</label>
                <input type="text" class="input-control" placeholder="Enter ID / Passport Number" [(ngModel)]="selectedPatient.IDNumber" id="IDNumber" name="IDNumber" #IDNumber="ngModel" [ngClass]="{'invalid-border': IDNumber.invalid && submitted}" required tabindex="12" />
              </div>
              <div class="patient-details">
                <!--detail group-->
                <div class="details-column">
                  <div class="form-group">
                    <app-custom-dropdown [options]="titles"
                                         [placeholder]="'Title'"
                                         [(ngModel)]="selectedPatient.Title"
                                         [ngModelOptions]="{standalone: true}"
                                         [optionsText]="'Type'"
                                         [optionsValue]="'Type'"
                                         tabindex="13">
                    </app-custom-dropdown>
                  </div>

                  <div class="form-group">
                    <app-custom-dropdown [options]="genders"
                                         [placeholder]="'Gender'"
                                         [(ngModel)]="selectedPatient.Gender"
                                         [ngModelOptions]="{standalone: true}"
                                         [optionsText]="'Type'"
                                         [optionsValue]="'ID'"
                                         tabindex="16">
                    </app-custom-dropdown>
                  </div>
                </div>
                <div class="details-column">
                  <div class="form-group">
                    <span *ngIf="Name.invalid && submitted" class="invalid-text">*</span>
                    <label>Patient Name:</label>
                    <input type="text" class="input-control" placeholder="Enter Patient Name" [(ngModel)]="selectedPatient.Name" id="Name" name="Name" #Name="ngModel"  [ngClass]="{'invalid-border': Name.invalid && submitted}" required tabindex="14" />
                  </div>
                  <div class="form-group">
                    <span *ngIf="Cellphone.invalid && submitted" class="invalid-text">*</span>
                    <label>Cellphone:</label>
                    <input type="tel" class="input-control" placeholder="Enter Patient Cellphone" [(ngModel)]="selectedPatient.Cellphone" id="Cellphone" name="Cellphone" #Cellphone="ngModel" [ngClass]="{'invalid-border': Cellphone.invalid && submitted}" required tabindex="18" />
                  </div>
                </div>
                <div class="details-column">
                  <div class="form-group">
                    <span *ngIf="Surname.invalid && submitted" class="invalid-text">*</span>
                    <label>Patient Surname:</label>
                    <input type="text" class="input-control" placeholder="Enter Patient Surname" [(ngModel)]="selectedPatient.Surname" id="Surname" name="Surname" #Surname="ngModel" [ngClass]="{'invalid-border': Surname.invalid && submitted}" required tabindex="15" />
                  </div>
                </div>
              </div>
            </div>
          </div>

            <!-- Patient Details: NEW / SELECT Section -->
            <div class="details-new column-gap 20" *ngIf="PopupAction == 'NEW' || PopupAction == 'SELECT'">
              <div class="title">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.14296 7.85721C9.1154 7.85721 10.7144 6.25823 10.7144 4.28578C10.7144 2.31334 9.1154 0.714355 7.14296 0.714355C5.17052 0.714355 3.57153 2.31334 3.57153 4.28578C3.57153 6.25823 5.17052 7.85721 7.14296 7.85721Z" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M7.14293 17.8573H0.714355V17.0828C0.725728 15.994 1.01289 14.9257 1.54903 13.9779C2.08517 13.0301 2.85278 12.2337 3.78017 11.663C4.70757 11.0923 5.76448 10.766 6.85218 10.7145C6.94916 10.7099 7.0461 10.7075 7.14293 10.7073C7.23976 10.7075 7.33671 10.7099 7.43368 10.7145C8.52138 10.766 9.5783 11.0923 10.5057 11.663C11.039 11.9912 11.5194 12.394 11.9334 12.8573" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M19.2858 12.1428L13.5715 19.2857L10.7144 17.1428" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h3>Patient Details</h3>
              </div>


              <!--View Pateint detail fields html-->
              <div class="patient-details" *ngIf="PopupAction == 'SELECT'" style=" gap: 5vw;">
                <div class="details-column">
                  <div class="content-group">
                    <label>Title:</label>
                    <p>{{selectedPatient.Title}}</p>
                  </div>
                  <div class="content-group">
                    <label>Patient ID / Passport Number:</label>
                    <p>{{selectedPatient.IDNumber}}</p>
                  </div>
                </div>
                <div class="details-column">
                  <div class="content-group">
                    <label>Patient Name:</label>
                    <p>{{selectedPatient.Name}}</p>
                  </div>
                  <div class="content-group">
                    <label>Cellphone:</label>
                    <p>{{selectedPatient.Cellphone}}</p>
                  </div>
                </div>
                <div class="details-column">
                  <div class="content-group">
                    <label>Patient Status:</label>
                    <p><strong>{{selectedPatient.Status}}</strong></p>
                  </div>

                </div>
              </div>
              <!--Setup Pateint detail fields html-->
              <div class="column gap-20" *ngIf="PopupAction == 'NEW'">
                <div class="form-group">
                  <span *ngIf="IDNumber.invalid && submitted" class="invalid-text">*</span>
                  <label>Patient ID / Passport Number:</label>
                  <input type="text" class="input-control" placeholder="Enter ID / Passport Number" [(ngModel)]="selectedPatient.IDNumber" id="IDNumber" name="IDNumber" #IDNumber="ngModel" [ngClass]="{'invalid-border': IDNumber.invalid && submitted}" required tabindex="12" />
                </div>
                <div class="patient-details">
                  <!--detail group-->
                  <div class="details-column">
                    <div class="form-group">
                      <app-custom-dropdown [options]="titles"
                                           [placeholder]="'Title'"
                                           [(ngModel)]="selectedPatient.Title"
                                           [ngModelOptions]="{standalone: true}"
                                           [optionsText]="'Type'"
                                           [optionsValue]="'Type'"
                                           tabindex="13">
                      </app-custom-dropdown>
                    </div>

                    <div class="form-group">
                      <app-custom-dropdown [options]="genders"
                                           [placeholder]="'Gender'"
                                           [(ngModel)]="selectedPatient.Gender"
                                           [ngModelOptions]="{standalone: true}"
                                           [optionsText]="'Type'"
                                           [optionsValue]="'ID'"
                                           tabindex="16">
                      </app-custom-dropdown>
                    </div>
                  </div>
                  <div class="details-column">
                    <div class="form-group">
                      <span *ngIf="Name.invalid && submitted" class="invalid-text">*</span>
                      <label>Patient Name:</label>
                      <input type="text" class="input-control" placeholder="Enter Patient Name" [(ngModel)]="selectedPatient.Name" id="Name" name="Name" #Name="ngModel" [ngClass]="{'invalid-border': Name.invalid && submitted}" required tabindex="14" />
                    </div>
                    <div class="form-group">
                      <span *ngIf="Cellphone.invalid && submitted" class="invalid-text">*</span>
                      <label>Cellphone:</label>
                      <input type="tel" class="input-control" placeholder="Enter Patient Cellphone" [(ngModel)]="selectedPatient.Cellphone" id="Cellphone" name="Cellphone" #Cellphone="ngModel" [ngClass]="{'invalid-border': Cellphone.invalid && submitted}" required tabindex="18" />
                    </div>
                  </div>
                  <div class="details-column">
                    <div class="form-group">
                      <span *ngIf="Surname.invalid && submitted" class="invalid-text">*</span>
                      <label>Patient Surname:</label>
                      <input type="text" class="input-control" placeholder="Enter Patient Surname" [(ngModel)]="selectedPatient.Surname" id="Surname" name="Surname" #Surname="ngModel" [ngClass]="{'invalid-border': Surname.invalid && submitted}" required tabindex="15" />
                    </div>
                    <div class="form-group">
                      <span *ngIf="ConfCellphone.invalid && submitted" class="invalid-text">*</span>
                      <label>Confirmation Cellphone:</label>
                      <input type="text" class="input-control" placeholder="Enter Cellphone Confirmation" [(ngModel)]="appointment.ConfirmationCellphone" id="ConfCellphone" name="ConfCellphone" #ConfCellphone="ngModel" [ngClass]="{'invalid-border': ConfCellphone.invalid && submitted}" required tabindex="19" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <hr style=" margin: 10px 0;" />
          <!-- Services Section -->
          <div class="column gap-20">
            <div class="title">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
                <path d="M17.7258 14.6772C18.021 14.3968 18.2561 14.0593 18.4169 13.6851C18.5775 13.311 18.6605 12.908 18.6605 12.5008C18.6605 12.0936 18.5775 11.6907 18.4169 11.3165C18.2561 10.9424 18.021 10.6048 17.7258 10.3244C17.1214 9.75073 16.3198 9.43091 15.4865 9.43091C14.6532 9.43091 13.8516 9.75073 13.2472 10.3244L11.0001 12.5715L8.75292 10.3244C8.14848 9.75073 7.34694 9.43091 6.51363 9.43091C5.6803 9.43091 4.87876 9.75073 4.27434 10.3244C3.97906 10.6048 3.74394 10.9424 3.58326 11.3165C3.42258 11.6907 3.33972 12.0936 3.33972 12.5008C3.33972 12.908 3.42258 13.311 3.58326 13.6851C3.74394 14.0593 3.97906 14.3968 4.27434 14.6772L11.0001 21.2143L17.7258 14.6772Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11 7.07148C12.7358 7.07148 14.1429 5.66438 14.1429 3.92862C14.1429 2.19287 12.7358 0.785767 11 0.785767C9.26428 0.785767 7.85718 2.19287 7.85718 3.92862C7.85718 5.66438 9.26428 7.07148 11 7.07148Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <h3> Services </h3>
            </div>
            <div class="row gap-30">
              <div class="form-group form-group-column">
                <div class="title">
                  <h3>Service Type</h3>
                </div>
                <app-custom-dropdown [options]="SP_Types"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="appointment.SPType"
                                     [ngModelOptions]="{standalone: true}"
                                     [optionsText]="'SPType'"
                                     [optionsValue]="'SPType'"
                                     (ngModelChange)="onServiceTypeChange()"
                                     tabindex="21">
                </app-custom-dropdown>
              </div>
              <div class="form-group form-group-column" *ngIf="appointment.SPType">
                <div class="title">
                  <h3>Service</h3>
                </div>
                <app-custom-dropdown [options]="filteredServices"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="appointment.ServiceProviderID"
                                     [ngModelOptions]="{standalone: true}"
                                     [optionsText]="'Name'"
                                     [optionsValue]="'ID'"
                                     (ngModelChange)="onServiceChange()"
                                     tabindex="22">
                </app-custom-dropdown>
              </div>
              <div class="form-group form-group-column" *ngIf="appointment.Duration > 0">
                <div class="title">
                  <h3>Duration</h3>
                </div>
                <div class="custom-input-placeholder">
                  <input type="text" class="form-control text-transform-none" value="{{appointment.Duration}}{{'min'}}" disabled />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group form-group-column">
                <div class="title">
                  <h3 style="color: var(--error-color) !important;">Override</h3>
                </div>
                <app-custom-dropdown [options]="durations"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="durationOveride"
                                     [ngModelOptions]="{standalone: true}"
                                     [optionsText]="'Description'"
                                     [optionsValue]="'Description'"
                                     (ngModelChange)="selectDuration()"
                                     textSuffix="min"
                                     tabindex="23">
                </app-custom-dropdown>
              </div>
            </div>
          </div>

          <hr style=" margin: 10px 0;" />
          <!-- Patient Notes Section -->
          <div class="notes column gap-20">
            <div class="title">
              <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.9285 2.35718H15.2857C15.7024 2.35718 16.1022 2.52274 16.3968 2.81743C16.6915 3.11214 16.8571 3.51183 16.8571 3.92861V19.6429C16.8571 20.0596 16.6915 20.4594 16.3968 20.7541C16.1022 21.0487 15.7024 21.2143 15.2857 21.2143H2.71425C2.29748 21.2143 1.89778 21.0487 1.60308 20.7541C1.30839 20.4594 1.14282 20.0596 1.14282 19.6429V3.92861C1.14282 3.51183 1.30839 3.11214 1.60308 2.81743C1.89778 2.52274 2.29748 2.35718 2.71425 2.35718H5.07139" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.357 0.785645H6.64272C5.77485 0.785645 5.07129 1.4892 5.07129 2.35707V3.14279C5.07129 4.01066 5.77485 4.71422 6.64272 4.71422H11.357C12.2249 4.71422 12.9284 4.01066 12.9284 3.14279V2.35707C12.9284 1.4892 12.2249 0.785645 11.357 0.785645Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.9042 8.18701C7.53155 8.18701 7.22946 8.4891 7.22946 8.86177V10.7595H5.33172C4.95907 10.7595 4.65698 11.0616 4.65698 11.4343V13.6272C4.65698 13.9998 4.95907 14.3019 5.33172 14.3019H7.22946V16.1996C7.22946 16.5722 7.53155 16.8744 7.9042 16.8744H10.0971C10.4698 16.8744 10.7719 16.5722 10.7719 16.1996V14.3019H12.6696C13.0423 14.3019 13.3443 13.9999 13.3443 13.6272V11.4343C13.3443 11.0616 13.0423 10.7595 12.6696 10.7595H10.7719V8.86177C10.7719 8.4891 10.4698 8.18701 10.0971 8.18701H7.9042Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <h3>Patient Notes</h3>
            </div>
            <div class="form-group">
              <div class="custom-input-placeholder">
                <span class="custom-placeholder" *ngIf="!appointment.AppointmentNotes">Enter Patient Notes</span>
                <input type="text" class="form-control" [(ngModel)]="appointment.AppointmentNotes" [ngModelOptions]="{standalone: true}" tabindex="24" />
              </div>
            </div>
          </div>
          <div *ngIf="showError == true" class="error-popup row">
            <h3 class="error-message">* {{erroMessage}}</h3>
          </div>
          <!-- Buttons Section -->
          <div class="popup-buttons" style=" margin: 10px 0;">
            <button class="popup-btn" type="button" (click)="navigateToView()">Back</button>
            <button class="popup-btn" type="button" (click)="PopupEvent('close')">Cancel</button>
            <button class="popup-btn" type="submit" >Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
